<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Consulta de NFe</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <!-- <li>
                    <a @click="onCreate()" v-b-tooltip title="Cadastrar"
                      ><i class="ft-plus"></i
                    ></a>
                  </li> -->
                  <li>
                    <a @click="onExport()" v-b-tooltip title="Exportar"
                      ><i class="ft-download"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onExportCsv()"
                      v-b-tooltip
                      title="Exportar chaves em .csv"
                      ><i class="fa fa-file-code-o"></i
                    ></a>
                  </li>
                  <!-- <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros" v-if="getPermission('unidade.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inativar Registros" v-if="getPermission('unidade.status')"><i class="fa fa-thumbs-o-down"></i></a></li> -->
                  <!-- <li>
                    <a
                      @click="onCreateRespacho()"
                      v-if="
                        this.$refs.vuetable &&
                        this.$refs.vuetable.selectedTo.length > 0
                      "
                      v-b-tooltip
                      title="Cadastrar Motorista Redespacho"
                      ><i class="fa fa-truck"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onImportXml()"
                      v-b-tooltip
                      title="Importar XML NFe"
                      v-if="getPermissionFw('xmlnfe.import')"
                      ><i class="fa fa-code step-xml-nfe"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onImportXmlCte()"
                      v-b-tooltip
                      title="Importar XML CTe"
                      v-if="getPermissionFw('xmlcte.import')"
                      ><i class="fa fa-codepen step-xml-cte"></i
                    ></a>
                  </li> -->
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                      @click="searchAll()"
                      v-b-tooltip
                      title="Selecionar todas as páginas"
                      v-if="getPermissionFw('montagemcarga.index')"
                      ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                      ></i
                    ></a>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/exportacaodocfiscal"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="docfis_id"
                    pagination-path=""
                    detail-row-component="consutanfe-detalhes"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="dt_emissao" slot-scope="props">
                      <span>{{ formatDate(props.rowData.dt_emissao) }}</span>
                    </template>
                    <template slot="num_carga" slot-scope="props">
                      <span v-if="props.rowData.carga_bip_doc != null">{{
                        props.rowData.carga_bip_doc.carga.num_carga
                      }}</span>
                    </template>
                    <template slot="cte" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.carga_doc != null &&
                          props.rowData.carga_doc.doc_carga_doc != null
                        "
                        >{{
                          props.rowData.carga_doc.doc_carga_doc.doc.num_fiscal
                        }}</span
                      >
                    </template>
                    <template slot="emissor" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.doc_fiscal_partes_env.emi_cnpj != null
                        "
                        >{{
                          ajustaMascara(
                            props.rowData.doc_fiscal_partes_env.emi_cnpj,
                            2
                          )
                        }}</span
                      >
                      <span
                        v-if="
                          props.rowData.doc_fiscal_partes_env.emi_cpf != null
                        "
                        >{{
                          ajustaMascara(
                            props.rowData.doc_fiscal_partes_env.emi_cpf,
                            1
                          )
                        }}</span
                      >
                    </template>

                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onExport(props.rowData.docfis_id)"
                          v-b-tooltip
                          title="Exportar"
                          ><i class="ft-download"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ManutencaoNotaFiscal ref="manutencaonotafiscal" />
      <GerenciamentoTransporteExportacao
        ref="gerenciamentotransporteexportacao"
        :rota="'exportacaodocfiscal'"
      />

      <ManutencaoNotaFiscalRedespachoModal
        ref="manutencaonotafiscalredespachomodal"
      />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import moment from "moment";
import ManutencaoNotaFiscal from "./ManutencaoNotaFiscalForm.vue";
import ConsultaNotaFiscaisFilterBar from "./ConsultaNotaFiscalFilterBar.vue";
import ConsultaNotaFiscalDetalhes from "./ConsultaNotaFiscalDetalhes.vue";
import ManutencaoNotaFiscalRedespachoModal from "./ManutencaoNotaFiscalRedespachoModal.vue";
import GerenciamentoTransporteExportacao from "./GerenciamentoTransporteExportacao.vue";

Vue.component("consutanfe-detalhes", ConsultaNotaFiscalDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ManutencaoNotaFiscal,
    ConsultaNotaFiscalDetalhes,
    ManutencaoNotaFiscalRedespachoModal,
    GerenciamentoTransporteExportacao,
    "vuetable-filterbar": ConsultaNotaFiscaisFilterBar,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalDoc: false,
      showModalConta: false,
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      showModalXml: false,
      showModalXmlCTe: false,
      isFullscreen: false,
      data: [],
      optionsPessoaParceira: [],
      optionsTpProcesso: [],
      optionsMunicipios: [],
      optionsStatusImportacao: [],
      optionsModalidadeFrete: [],
      filter_data_store: {},
      form: new FileForm({
        file: null,
        data: [],
      }),
      filtros_form: new Form({
        nf_ini: "",
        nf_fim: "",
        dt_nf_emi_ini: "",
        dt_nf_emi_fim: "",
        num_carga: "",
        cte_ini: "",
        cte_fim: "",
        dt_cte_emi_ini: "",
        dt_cte_emi_fim: "",
        cnpj_origem: "",
        mdfe: "",
        chave: "",
        email_usuario_inc: "",
        redespacho: "",
        unidade_parceira: "",
        tp_processo_cte: "",
      }),
      form1: new Form({
        docfis: [],
        docs: [],
      }),
      //número da nota, serie da nota, data de emissão da nota, emissor da nota e unidade da nota fiscal tb pf
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_fiscal",
          title: "Número da nota",
        },
        {
          name: "serie",
          title: "Serie da Nota",
        },
        {
          name: "__slot:dt_emissao",
          title: "Data de emissão",
        },
        {
          name: "__slot:emissor",
          title: "Emissor da nota",
        },
        {
          name: "__slot:cte",
          title: "Cte",
        },
        {
          name: "__slot:num_carga",
          title: "N° Carga",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function (data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        nf_ini: data_filter.nf_ini,
        nf_fim: data_filter.nf_fim,
        dt_nf_emi_ini: data_filter.dt_nf_emi_ini,
        dt_nf_emi_fim: data_filter.dt_nf_emi_fim,
        num_carga: data_filter.num_carga,
        cte_ini: data_filter.cte_ini,
        cte_fim: data_filter.cte_fim,
        dt_cte_emi_ini: data_filter.dt_cte_emi_ini,
        dt_cte_emi_fim: data_filter.dt_cte_emi_fim,
        cnpj_origem: data_filter.cnpj_origem, 
        mdfe: data_filter.mdfe,
        chave: data_filter.chave,
        email_usuario_inc: data_filter.email_usuario_inc,
        redespacho: data_filter.redespacho.pessoa_id,
        unidade_parceira: data_filter.unidade_parceira.value,
        tp_processo_cte: data_filter.tp_processo_cte.value,
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
        // this.onCreateDoc(this.moreParams, 2);
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    searchAll(data_filter, tipo) {
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.nf_ini = this.filter_data_store.nf_ini;
          this.filtros_form.nf_fim = this.filter_data_store.nf_fim;
          this.filtros_form.dt_nf_emi_ini =
            this.filter_data_store.dt_nf_emi_ini;
          this.filtros_form.dt_nf_emi_fim =
            this.filter_data_store.dt_nf_emi_fim;
          this.filtros_form.num_carga = this.filter_data_store.num_carga;
          this.filtros_form.cte_ini = this.filter_data_store.cte_ini;
          this.filtros_form.cte_fim = this.filter_data_store.cte_fim;
          this.filtros_form.dt_cte_emi_ini =
            this.filter_data_store.dt_cte_emi_ini;
          this.filtros_form.dt_cte_emi_fim =
            this.filter_data_store.dt_cte_emi_fim;
          this.filtros_form.cnpj_origem = this.filter_data_store.cnpj_origem;
          this.filtros_form.mdfe = this.filter_data_store.mdfe;
          this.filtros_form.chave = this.filter_data_store.chave;
          this.filtros_form.email_usuario_inc =
            this.filter_data_store.email_usuario_inc;
          this.filtros_form.redespacho = this.filter_data_store.redespacho;
          this.filtros_form.unidade_parceira =
            this.filter_data_store.unidade_parceira;
          this.filtros_form.tp_processo_cte =
            this.filter_data_store.tp_processo_cte;
          this.filtros_form
            .post("/api/exportacaodocfiscal/all")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);
              response.forEach((obj) => {
                this.$refs.vuetable.selectedTo.push(parseFloat(obj));
              });
              this.loadingData = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
              this.loadingData = false;
            });
        } else {
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      this.filter_data_store = {};
      this.$refs.vuetable.selectedTo = [];
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.docfis_id);
      }
    },
    onCreate() {
      this.$refs.manutencaonotafiscal.onCreate();
    },
    onEdit(data, index) {
      this.$refs.manutencaonotafiscal.onEdit(data);
    },

    onExport(data) {
      this.form1.docfis = [];
      if (this.$refs.vuetable.selectedTo.length > 0) {
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.form1.docfis.push(obj);
        });
        data = this.form1.docfis;
      } else {
        this.form1.docfis.push(data);
        data = this.form1.docfis;
      }
      this.$refs.gerenciamentotransporteexportacao.onExport(data);
      this.$refs.vuetable.selectedTo = [];
    },

    onExportCsv() {
      this.loading = true;
      this.isDisabled = true;
      this.form1.docs = [];
      if (this.$refs.vuetable.selectedTo.length > 0) {
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.form1.docs.push(obj);
        });
        this.form1
          .post("/api/exportacaodocfiscal/chave")
          .then((response) => {
            new ReturnApi(response, this, true, false, false, false);
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = "";
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          });
      } else {
        alert("Selecione pelo menos uma NFe");
      }
    },

    onCreateRespacho(data) {
      this.form1.docfis = [];
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.form1.docfis.push({ docfis_id: obj });
      });
      data = this.form1.docfis;
      this.$refs.manutencaonotafiscalredespachomodal.onCreate(data);
      this.$refs.vuetable.selectedTo = [];
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },

    getLivGeral() {
      this.helpForm
        .get("/api/exportacaodocfiscal/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);

          response.pessoa_parceira.forEach((obj) => {
            this.optionsPessoaParceira.push({
              label: obj.descr,
              value: obj.pespar_id,
            });
          });

          response.tp_processo.forEach((obj) => {
            this.optionsTpProcesso.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.docfis_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.manutencaonotafiscal.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    ajustaMascara(data, tipo) {
      if (tipo === 1) {
        //cpf
        return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      if (tipo === 2) {
        //cnpj
        return data.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
<style>
.form-check {
  padding: 0 1.25rem;
}
</style>
